/** Impl dos use cases de cadastros de Protocolo. @since G.5.5 */
import type {
  ProtocoloSetor, ProtocoloSetorCommand,
  ProtocoloAssunto, ProtocoloAssuntoCommand,
} from '@/domain/model/Protocolo';
import type { Page } from '@/domain/model/Page';
import type {
  ProtocoloSetorGateway, ProtocoloAssuntoGateway,
  ListProtocoloSetoresParams, ListProtocoloAssuntosParams,
} from '@/application/port/out/ProtocoloCadastrosGateway';
import type {
  ListProtocoloSetoresUseCase, GetProtocoloSetorUseCase, CreateProtocoloSetorUseCase,
  UpdateProtocoloSetorUseCase, DeactivateProtocoloSetorUseCase,
  ListProtocoloAssuntosUseCase, GetProtocoloAssuntoUseCase, CreateProtocoloAssuntoUseCase,
  UpdateProtocoloAssuntoUseCase, DeactivateProtocoloAssuntoUseCase,
} from '@/application/port/in/ProtocoloCadastrosUseCase';

// Setor
export class ListProtocoloSetores implements ListProtocoloSetoresUseCase {
  constructor(private readonly g: ProtocoloSetorGateway) {}
  execute(params?: ListProtocoloSetoresParams): Promise<Page<ProtocoloSetor>> { return this.g.list(params); }
}
export class GetProtocoloSetor implements GetProtocoloSetorUseCase {
  constructor(private readonly g: ProtocoloSetorGateway) {}
  execute(id: string): Promise<ProtocoloSetor> { return this.g.get(id); }
}
export class CreateProtocoloSetor implements CreateProtocoloSetorUseCase {
  constructor(private readonly g: ProtocoloSetorGateway) {}
  execute(cmd: ProtocoloSetorCommand): Promise<ProtocoloSetor> { return this.g.create(cmd); }
}
export class UpdateProtocoloSetor implements UpdateProtocoloSetorUseCase {
  constructor(private readonly g: ProtocoloSetorGateway) {}
  execute(id: string, cmd: ProtocoloSetorCommand): Promise<ProtocoloSetor> { return this.g.update(id, cmd); }
}
export class DeactivateProtocoloSetor implements DeactivateProtocoloSetorUseCase {
  constructor(private readonly g: ProtocoloSetorGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}

// Assunto
export class ListProtocoloAssuntos implements ListProtocoloAssuntosUseCase {
  constructor(private readonly g: ProtocoloAssuntoGateway) {}
  execute(params?: ListProtocoloAssuntosParams): Promise<Page<ProtocoloAssunto>> { return this.g.list(params); }
}
export class GetProtocoloAssunto implements GetProtocoloAssuntoUseCase {
  constructor(private readonly g: ProtocoloAssuntoGateway) {}
  execute(id: string): Promise<ProtocoloAssunto> { return this.g.get(id); }
}
export class CreateProtocoloAssunto implements CreateProtocoloAssuntoUseCase {
  constructor(private readonly g: ProtocoloAssuntoGateway) {}
  execute(cmd: ProtocoloAssuntoCommand): Promise<ProtocoloAssunto> { return this.g.create(cmd); }
}
export class UpdateProtocoloAssunto implements UpdateProtocoloAssuntoUseCase {
  constructor(private readonly g: ProtocoloAssuntoGateway) {}
  execute(id: string, cmd: ProtocoloAssuntoCommand): Promise<ProtocoloAssunto> { return this.g.update(id, cmd); }
}
export class DeactivateProtocoloAssunto implements DeactivateProtocoloAssuntoUseCase {
  constructor(private readonly g: ProtocoloAssuntoGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
